<template>
  <div class="container">
    <div class="card card-container">
      <div class="message">
        <p class="errMsg w260">{{ message }}</p>
      </div>
      <ValidationObserver ref="observer" tag="form">
        <ValidationProvider mode="eager" v-slot="{ errors }" rules="required">
          <span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
          <input id="userId" :name="itemName.userId" type="text" class="form-control mb10"
            v-model="userId" placeholder="ユーザID" autofocus autocomplete="off" @keyup.enter="login">
        </ValidationProvider>
        <ValidationProvider mode="eager" v-slot="{ errors }" rules="required">
          <span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
          <input :name="itemName.userPassword" type="password" class="form-control mb10"
            v-model="userPassword" placeholder="パスワード" autocomplete="off" @keyup.enter="login">
        </ValidationProvider>
        <ValidationProvider mode="eager" v-slot="{ errors }" rules="required">
          <span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
          <input id="domain" :name="itemName.domain" type="text" class="form-control mb10"
            v-model="domain" placeholder="ドメイン" autocomplete="off" @keyup.enter="login">
        </ValidationProvider>
        <RfidButton :loginPage=true @handleClick="login">ログイン</RfidButton>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import RfidButton from '@/components/atoms/RfidButton'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'login',

  components: {
    ValidationProvider,
    RfidButton,
    ValidationObserver
  },

  props: {
    propMessage: null
  },

  data () {
    return {
      message: '',
      userId: '',
      userPassword: '',
      domain: '',
      itemName: {}
    }
  },

  mounted () {
    if (this.$session) {
      this.$session.destroy()
      this.$emit('notDisplayHeader')
    }
  },

  created () {
    this.$emit('setMessage', null, false)
    if (this.$session) {
      this.$session.destroy()
      this.$emit('notDisplayHeader')
    }
    this.message = this.propMessage
    this.itemName = this.item()
  },

  methods: {
    async login () {
      this.$emit('setMessage', null, false)
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }

      // 従業員認証API
      this.axios.post('/api/auth/employee', {
        'userId': this.userId,
        'userPassword': this.userPassword,
        'domain': this.domain
      }, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        // セッションの作成
        this.$session.start()
        this.$session.set('data', response.data)
        this.$session.set('accessToken', response.data.accessToken)
        this.$session.set('enterpriseCode', response.data.enterpriseCode)
        this.$session.set('enterpriseName', response.data.enterpriseName)
        this.$session.set('businessType', response.data.businessType)
        this.$session.set('sectionCode', response.data.sectionCode)
        this.$session.set('sectionName', response.data.sectionName)
        this.$session.set('userName', response.data.userName)
        this.$session.set('userId', response.data.userId)
        this.$session.set('userDiv', response.data.userDiv)
        this.$session.set('manualInventoryPermitDiv', response.data.manualInventoryPermitDiv)
        this.$session.set('simpleAuthenticationDiv', response.data.simpleAuthenticationDiv)
        this.$session.set('inventoryDeleteDiv', response.data.inventoryDeleteDiv)
        this.$session.set('inventoryCancelDiv', response.data.inventoryCancelDiv)
        this.$session.set('inventoryDownloadDiv', response.data.inventoryDownloadDiv)
        this.$session.set('stockFileOperationDiv', response.data.stockFileOperationDiv)
        this.$session.set('inventoryCompletionDiv', response.data.inventoryCompletionDiv)
        this.$session.set('readerSettingDiv', response.data.readerSettingDiv)

        this.$emit('login', true, response.data.userDiv, response.data.enterpriseName, response.data.userName)
      }).catch((e) => {
        this.message = '認証できませんでした。'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue